export interface Product {
  id: string
  name: string
  description: string
  price: number
  interval: "month" | "year"
  features: string[]
  highlighted?: boolean
  priceId?: string // Stripe Price ID (null for free)
}

export const PRODUCTS: Product[] = [
  {
    id: "irene-free",
    name: "Free",
    description: "Get started with investor relations basics",
    price: 0,
    interval: "month",
    features: [
      "Up to 25 investors",
      "1 deal room",
      "3 AI updates / month",
      "1 deck analysis / month",
      "Basic CRM features",
    ],
  },
  {
    id: "irene-starter",
    name: "Starter",
    description: "For early-stage founders building their pipeline",
    price: 49,
    interval: "month",
    priceId: "price_1SyhAhRBii4S4KdW5XRdIKCz",
    features: [
      "Up to 100 investors",
      "2 deal rooms",
      "20 AI updates / month",
      "5 deck analyses / month",
      "Full CRM features",
      "Email support",
    ],
  },
  {
    id: "irene-growth",
    name: "Growth",
    description: "For startups actively fundraising",
    price: 149,
    interval: "month",
    highlighted: true,
    priceId: "price_1SyhFIRBii4S4KdWW9ysk6r6",
    features: [
      "Up to 500 investors",
      "5 deal rooms",
      "Unlimited AI updates",
      "Unlimited deck analyses",
      "AI investor search",
      "Priority support",
    ],
  },
  {
    id: "irene-scale",
    name: "Scale",
    description: "For established startups with complex needs",
    price: 349,
    interval: "month",
    priceId: "price_1SyhFLRBii4S4KdWkSe7FfLQ",
    features: [
      "Unlimited investors",
      "Unlimited deal rooms",
      "All AI features",
      "Custom integrations",
      "API access",
      "Dedicated support",
    ],
  },
]

/** Map backend plan name to product */
export function getProductByPlan(plan: string): Product | undefined {
  const map: Record<string, string> = {
    free: "irene-free",
    starter: "irene-starter",
    growth: "irene-growth",
    scale: "irene-scale",
  }
  return PRODUCTS.find((p) => p.id === map[plan])
}
